const CancelablePromise = require("mn-utils/CancelablePromise");
const {get, post} = require("../../http");
import {getInvoiceDetails, getInvoiceList} from "./mock";

export function apiV1WithdrawList(params) {
  const url = '/f2c/v1/console/withdrawals';
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getInvoiceList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}

export function apiV1WithdrawGet(params) {
  const url = '/f2c/v1/console/withdrawal/' + params.id;
  if (process.env.MOCK) {
    const response = getInvoiceDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url);
}

export function apiV1WithdrawInit(params) {
  const url = '/f2c/v1/console/withdrawal';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return post(url, params);
}
